import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { Typography } from 'antd'

import { icons } from 'portal/lib/primitives'

import {
  Tile,
  TileNumber,
  TileRow,
  Tiles,
  TitleBar,
  TitleBarIcon
} from './commonStyles'

export const Utilities = () => {
  const { Title } = Typography

  return (
    <>
      <TitleBar>
        <TitleBarIcon>
          <icons.Modules.Electricity />
        </TitleBarIcon>
        <Title level={4}>Utilities</Title>
      </TitleBar>
      <Tiles
        style={{ gridTemplateColumns: '1fr 1fr', marginBottom: '0.75rem' }}
      >
        <Tile style={{ minHeight: 0 }}>
          <TileRow>
            <Title level={5} style={{ fontSize: '1rem' }}>
              Water meters
            </Title>
          </TileRow>
        </Tile>
        <Tile style={{ minHeight: 0 }}>
          <TileRow>
            <Title level={5} style={{ fontSize: '1rem' }}>
              Electricity meters
            </Title>
          </TileRow>
        </Tile>
      </Tiles>
      <Tiles style={{ gridTemplateColumns: '1fr 1fr 1fr 1fr' }}>
        <Tile>
          <TileRow>
            <Title level={5}>Total</Title>
          </TileRow>
          <TileRow>
            <TileNumber>13</TileNumber>
          </TileRow>
        </Tile>
        <Tile>
          <TileRow>
            <Title level={5}>December readings</Title>
          </TileRow>
          <TileRow>
            <TileNumber>
              3 <span style={{ fontSize: '1rem' }}>of</span> 13
            </TileNumber>
          </TileRow>
        </Tile>
        <Tile>
          <TileRow>
            <Title level={5}>Total</Title>
          </TileRow>
          <TileRow>
            <TileNumber>12</TileNumber>
          </TileRow>
        </Tile>

        <Tile>
          <TileRow>
            <Title level={5}>December readings</Title>
          </TileRow>
          <TileRow>
            <TileNumber>
              5 <span style={{ fontSize: '1rem' }}>of</span> 12
            </TileNumber>
          </TileRow>
        </Tile>
      </Tiles>
    </>
  )
}
